<div class="glitch-inline">
    <div class="consoleHeader" consoleHeaderOffset
    [ngClass]="AppSettings.IsRunningInSingularity ? 'consoleHeader-sso' : ''" *ngIf="RequestModel && !IsSubmitting">
        <div class="row flex-nowrap">
            <div class="col-auto topFilters header_section">
                <a *ngFor="let row of PropStatModel" [ngClass]="(RequestModel.Status == row.Id ? 'active' : '')" href="javascript:{}" (click)="onTopFilter(row.Id)">
                    <div class="topFilter_Label text-center">{{row.Label | translate}} ({{row.Value}})</div>
                </a>
            </div>
        </div>
    </div>

    <div>
        <GlitchSearchResult #glitchSearchResult [Compact_Mode]="true"></GlitchSearchResult>
    </div>
</div>


